import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import PropTypes from 'prop-types';
import './PackageCard.scss';
import FuntoneButton from '../FuntoneButton/FuntoneButton';
import musicNote from './Images/musicNote.svg';

const PackageCard = ({packageItem, onSelect, isChangePackageFlow, selectedPackage}) => {
  const title = packageItem?.title.value || '';
  const price = packageItem?.price.value || '';
  const description = packageItem?.description.value || '';
  const buttonText = isChangePackageFlow ? 'תעדכנו לי' : 'להצטרפות והורדת שיר';

  const wideClass = isChangePackageFlow && selectedPackage ? 'package-card-wide' : '';
  return (
    <div className={`package-card ${wideClass}`} data-node-id='package-card'>
      <div className='package-inner'>
        <div className='package-header'>
          <div className='package-icon'>
            <Image src={musicNote} alt='' />
          </div>
          <div className='package-title'>{title}</div>
        </div>

        <div className='divider' />

        <div className='package-body'>
          <div className='price-row'>
            <div className='price'>₪{price}</div>
            <div className='period'>לחודש</div>
          </div>
          <div className='description'>{description}</div>
        </div>
      </div>

      {(!selectedPackage) && (
        <div className='package-action'>
          <FuntoneButton variant='primary' text={buttonText} onClick={() => onSelect && onSelect(packageItem)} />
        </div>
      )}
    </div>
  );
};

export default React.memo(PackageCard);
